import {request} from "../request/request";

const settingOlympiad = {
  findAll: (params) => request.read('/setting-olympiad', params, true),
  findOne: (params) => request.read('/setting-olympiad/find', params, true),
  getOne: (id) => request.read(`/setting-olympiad/${id}`, null, true),
};

export {settingOlympiad};